var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"alert-info",attrs:{"flat":""}},[_c('v-card-subtitle',[_c('h2',{staticClass:"subtitle-1 flex-grow-1"},[_vm._v(" Recommendations are currently available for some limited account types. "),_c('a',{attrs:{"target":"_blank","href":`${_vm.docsUrl}/Using/Tracking/#recommendations`}},[_vm._v("Learn more")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }